export class Payment {

    name: string;

    constructor(name: string) {
        this.name = name;
    }
}